import React, { forwardRef } from 'react';
import BootstrapButton from "../BootstrapButton";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
}

const SecondaryButton = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    const { className, children, ...rest } = props;

    return (
        <BootstrapButton
            ref={ref}
            variant={'secondary'}
            className={className}
            {...rest}
        >
            {children}
        </BootstrapButton>
    );
});

export default SecondaryButton;
